import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import React from 'react';
import PropTypes from 'prop-types';
import './claimSubmitSuccess.scss';
import { useNavigate } from 'react-router-dom';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';

const ClaimSubmitSuccess = ({
  title,
  subTitle,
  copy,
  showChequeMessage,
  handleChangeReimbursementMethod,
  hideButton
}) => {
  const navigate = useNavigate();
  return (
    <section className="claimSubmitSuccessContainer">
      <h2>{title}</h2>

      {showChequeMessage && (
        <div className="chequeMessage">
          <h3>You&rsquo;ve currently opted to receive claim payments via cheque.</h3>

          <Icon icon="banking" />

          <p>Get paid faster by updating your reimbursement method to bank transfer.</p>

          <button
            type="button"
            className="button primary outline chequeMessageButon"
            onClick={handleChangeReimbursementMethod}
          >
            <span className="labelText">Get faster claim payments</span>
          </button>
        </div>
      )}
      <Icon icon="paw" />
      <h3>{subTitle}</h3>
      {copy}
      {!hideButton && (
        <button
          type="button"
          className="button outline"
          onClick={() => navigate(CSPUrlsMap.dashboard.url)}
        >
          Back to Dashboard
        </button>
      )}
    </section>
  );
};

export default ClaimSubmitSuccess;

ClaimSubmitSuccess.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  copy: PropTypes.node.isRequired,
  showChequeMessage: PropTypes.bool,
  handleChangeReimbursementMethod: PropTypes.func,
  hideButton: PropTypes.bool
};
